import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {CommonUtils} from "../../utils/common";
import {AppStateService} from "../../providers/app-state.service";
import {Subscription} from "rxjs";
import {VisitLabTestData} from "../../models/visit-lab-test-data.model";
import {VisitLabTestDataService} from "../../providers/visit-lab-test-data.service";
import {LabTestDataObj} from "../../models/lab-test-data-obj.model";

@Component({
  selector: 'app-lab-data-edit',
  templateUrl: './lab-data-edit.component.html',
  styleUrls: ['./lab-data-edit.component.scss'],
})
export class LabDataEditComponent implements OnInit, OnDestroy {

  @Input() labTestData: VisitLabTestData;
  @Input() labTestDataObj: LabTestDataObj;
  @Input() vetReservationUUID: string;
  isAccepted: boolean = false;
  isBusy: boolean;
  isBusySub: Subscription;
  comment: string;
  @Output() acceptEmitter = new EventEmitter<VisitLabTestData>();
  @Output() closeEmitter = new EventEmitter<Boolean>();
  renderedLabTestData: string;

  constructor(public commonUtils: CommonUtils,
              private visitLabTestDataService: VisitLabTestDataService,
              private appStateService: AppStateService) {
  }

  ngOnInit() {
    this.renderedLabTestData = this.labTestData.renderedLabTestData;
    this.isBusySub = this.appStateService.isBusySubject.subscribe(e => {
      this.isBusy = e;
    });
    if (this.labTestData?.labTestDataComment) {
      this.comment = this.labTestData?.labTestDataComment;
    }

    console.log(this.labTestData)
  }

  onToggleAccept() {
    this.isAccepted = !this.isAccepted;
  }

  onAcceptAndSend() {
      this.commonUtils.presentYesNoActionSheet('Czy na pewno chcesz zatwierdzić wyniki badań i przesłać do użytkownika?', 'Tak', 'Nie', 'checkmark', 'close',
        () => {
          this.labTestData.labTestDataComment = this.comment;
          this.appStateService.updateIsBusySubject(true);

          this.visitLabTestDataService.sendLabTestData(this.labTestData).subscribe(e => {
            if (e) {
              this.commonUtils.presentInfoToast("Wyniki zostały przesłane do użytkownika");
              this.acceptEmitter.emit(e);
            } else {
              this.commonUtils.presentAlertToast("Wystąpił bład podczas akceptacji i przesyłania wyników do użytkownika");
            }
            this.appStateService.updateIsBusySubject(false);
          }, error => {
            this.appStateService.updateIsBusySubject(false);
            this.commonUtils.presentAlertToast("Wystąpił bład podczas akceptacji i przesyłania wyników do użytkownika");
          })

        }, () => {
          this.appStateService.updateIsBusySubject(false);
        })
  }

  ngOnDestroy(): void {
    if (this.isBusySub) {
      this.isBusySub.unsubscribe();
    }
  }

  onClose() {
    this.closeEmitter.emit(true);
  }
}
